<template>
    <div class="form-group col-12 col-lg-12 mb-0 p-0" v-if="!disabledInput">
        <label class="m-0 font-weight-bold " :for="id">{{ title }} </label>
        <div class="row">
            <div class="col-8 col-sm-8 col-md-8 col-lg-10 m-0">
                <input class="form-control"
                       :id="id"
                       :name="name" :value="value"
                       type="text" :disabled="disabledInput"
                       :placeholder="display_name">
            </div>
            <div class="col-2 col-sm-2 col-md-2 col-lg-1 m-0 p-0">
                <button :id="'success_'+name" @click="change" class="btn btn-outline-secondary" type="button" :title="$lang('Zapisz')">
                    <i :id="id+'_icon'" :class="classIcon" aria-hidden="true"></i>
                </button>
            </div>
            <div v-if="!disabledInput" class="col-2 col-sm-2 col-md-2 col-lg-1 m-0 p-0">
                <button type="button" class="btn btn-outline-secondary" :title="$lang('Anuluj')" @click.prevent="cancelEdit">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="form-group col-12 col-lg-12 text-input mb-2 p-0" v-else>
            <label  class="font-weight-bold mb-0" :for="id">{{ title }}
                <button v-if="editable" :id="'success_'+name" @click="change" class="btn btn-sm" type="button"><i :class="classIcon" aria-hidden="true"></i></button>
            </label>
            <br>
        {{ (value ? value : '-') }}
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";
export default {
    mixins:[ShowNotification],
    name: "input-text",
    props: [
        'title',
        'name',
        'task',
        'id',
        'url',
        'nullable',
        'elements',
        'equal',
        'display_name',
        'editable'
    ],
    methods: {
        cancelEdit() {
            this.disabledInput = true;
            this.classIcon = "fa fa-pencil";
        },
        change() {
            const inpt = $('#'+this.id);
            if(this.disabledInput){
                this.disabledInput = false;
                this.classIcon = "fa fa-check";
            }
            else if(!this.disabledInput){
                var data = {};
                data[this.name] = inpt.val();
                axios.post(this.url, data)
                    .then( (response) => {
                        this.successRequest();
                        this.showNotification('success','Zapisano');
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                this.value = data[this.name];
                this.disabledInput = true;
                this.classIcon = "fa fa-pencil";
            }
        },
        successRequest(){
            var $el = $('#success_'+this.name),
                x = 4000,
                originalBgColor = $el.css("background"),
                originalFontColor = $el.css("color");
            $el.css("transition", "background-color 0.5s ease");
            $el.css("transition", "color 0.5s ease");
            $el.css("background", "var(--primary-to-yellow)");
            $el.css("color", "var(--white-to-black)");
            setTimeout(function(){
                $el.css("background", originalBgColor);
                $el.css("color", originalFontColor);
            }, x);
        },

    },
    data() {
        return{
            classIcon:"fa fa-pencil",
            disabledInput: true,
            value: this.elements[this.name],
            value_name: this.name,
        }
    },
    mounted() {

    },
    created() {

    },
}
</script>

<style scoped>

</style>
